import React from 'react'
import { Popover } from 'react-bootstrap'

/**
 * Returns a Bootstrap popover displaying the passed string
 * @param {string} description content of the popover
 */
const DescriptionTooltipView = ( description ) => {
    return (
        <Popover id="popover-description">
            <Popover.Content>{description}</Popover.Content>
        </Popover>
    )
}

export { DescriptionTooltipView }